import React from 'react'

export default function Building29() {

      // Additional images for Variant Apartment Building
      const additionalImages = [
        "/images/Picture28.jpg",
        "/images/Picture51.jpg",
        "/images/Picture44.jpg",
      ];
  return (
        <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
          {/* Top Section: Text and Main Image */}
          <div className="flex flex-col lg:flex-row items-start gap-8">
            {/* Left Text Section */}
            <div className="lg:w-2/3 space-y-6">
              <h2 className="text-3xl font-bold text-gray-800">
                Variant Apartment Building at Plot No. 29
              </h2>
              <h3 className="text-2xl font-bold text-gray-800 leading-tight">
                Construction Services by PACIFIC BUILDERS (PVT) LTD
              </h3>
              <p className="text-gray-700">
                The Variant Apartment Building is a high-rise residential project in the heart of Lahore.
                <strong> PACIFIC BUILDERS (PVT) LTD</strong> is proud to be delivering precision-driven construction with the utmost quality and structural integrity for this modern development.
              </p>
    
              <div className="text-lg text-gray-700">
                <p><strong>Scope of Work:</strong> Structural works</p>
                <p><strong>Architect:</strong> Variant Architects</p>
                <p><strong>Covered Area:</strong> 210,000 sq ft</p>
                <p><strong>Status:</strong> Ongoing</p>
              </div>
            </div>
    
            {/* Right Image Section */}
            <div className="lg:w-1/3">
              <img
                src="/images/29A.jpg"
                alt="Variant Apartment Building Construction"
                className="w-full h-auto rounded shadow"
              />
            </div>
          </div>
    
          {/* Additional Images Section */}
          {additionalImages.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {additionalImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Variant Apartment ${index + 1}`}
                  className="w-full h-[250px] rounded shadow"
                />
              ))}
            </div>
          )}
        </div>
    
  )
}
